import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TextField, Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { getSingleCurrency, updateCurrencyValue } from '../../../services/api/CurrencyAPI'; // Adjust the import according to your file structure

const StyledContainer = styled(Container)`
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;

	& .MuiTextField-root {
		margin-bottom: 20px;
	}

	& .MuiButton-root {
		width: 100%;
	}
`;

const CurrencyConvert = () => {
	const [currencyValue, setCurrencyValue] = useState('');
	const [valueId, setValueId] = useState('');
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchCurrency = async () => {
			try {
				setLoading(true);
				const response = await getSingleCurrency();
				setCurrencyValue(response.data.value.toString());
				setValueId(response.data._id);
			} catch (error) {
				toast.error('Failed to fetch currency value.');
			} finally {
				setLoading(false);
			}
		};

		fetchCurrency();
	}, []);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let value = e.target.value;
		// Allow decimal numbers and empty value
		if (/^\d*\.?\d*$/.test(value)) {
			setCurrencyValue(value);
		}
	};

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		setLoading(true);
		e.preventDefault();
		if (currencyValue === '') {
			toast.error('Currency value cannot be empty.');
			return;
		}

		try {
			const response = await updateCurrencyValue(
				{ value: parseFloat(currencyValue) },
				valueId
			);
			if (response.success) {
				toast.success('Currency value updated successfully!');
			} else {
				toast.error('Failed to update currency value.');
			}
		} catch (error) {
			toast.error('Failed to update currency value.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<Container>
				<Typography
					gutterBottom
					style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
				>
					Currency Updater
				</Typography>
				<Typography
					className="d-flex"
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						flexDirection: { xs: 'column', sm: 'row', md: 'row' },
						marginBottom: '10px',
					}}
				>
					<div>
						<span
							style={{
								fontFamily: 'Poppins',
								fontWeight: '400',
								fontSize: '14px',
								color: '#006D48',
							}}
						>
							Manage your Currency updations.
						</span>
					</div>
				</Typography>

				<Grid container spacing={2}>
					<Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
						<StyledContainer maxWidth="sm" sx={{ padding: '0px !important' }}>
							<form onSubmit={handleSubmit} style={{ width: '100%' }}>
								<TextField
									label="Currency Value"
									value={currencyValue}
									type="text" // Change type to text to allow custom validation
									onChange={handleInputChange}
									// inputProps={{
									// 	min: 60,
									// 	max: 200,
									// 	pattern: '\\d*\\.?\\d*',
									// 	maxLength: 5,
									// }}
									slotProps={{
										htmlInput: {
											min: 60,
											max: 200,
											pattern: '\\d*\\.?\\d*', // Allows digits and an optional decimal point
											maxLength: 5,
											onInput: (
												event: React.ChangeEvent<HTMLInputElement>
											) => {
												// Ensure the input value adheres to the pattern and constraints
												const input = event.target as HTMLInputElement;
												const regex = /^\d*\.?\d*$/; // Matches digits and an optional decimal point
												if (!regex.test(input.value)) {
													input.value = input.value.replace(
														/[^\d.]/g,
														''
													); // Remove invalid characters
												}
											},
										},
									}}
									required
									fullWidth
								/>
								<Button
									type="submit"
									variant="contained"
									color="primary"
									disabled={loading}
								>
									Update
								</Button>
							</form>
						</StyledContainer>
					</Grid>
				</Grid>

				<ToastContainer />
			</Container>
		</div>
	);
};

export default CurrencyConvert;
